// import { patientInformationValidations } from "./patientInformationValidations";
import { authorizationToReleaseValidations } from "./authorizationToReleaseValidations";
import { informationToReleaseValidations } from "./informationToReleaseValidations";
import { deliveryMethodValidations } from "./deliveryMethodValidations";
import { purposeOfDisclosureValidations } from "./purposeOfDisclosureValidations";
import { discloseToValidations } from "./discloseToValidations";
import { formLevelValidations } from "./formLevelValidations";
import { supportingDocsValidations, supportingDocsValidationsProxy } from './supportingDocsValidations';
import { caseNumberValidations } from "./caseNumberValidations"
import { patientInfoValidations } from './patientInfoValidations';
import { additionalInfoValidations } from './additionalInfoValidations';
import { discloseSensitiveInfoValidations } from './discloseSensitiveInfoValidations';
import { repInfoValidations } from './repInfoValidations';

export const allValidations = (configTest, values, formType, dbFormSpec) => {



    const {
        // patientInformationSection,
        authorizationToReleaseSection,
        supportingDocsSection,
        discloseToSection,
        informationToReleaseSection,
        deliveryMethodSection,
        purposeOfDisclosureSection,
        caseNumberSection,
        repContactInfoSection,
        additionalInfoSection,
        disclosureOfSensitiveInformation
    } = configTest.page.form.sections;


    return patientInfoValidations(repContactInfoSection, formType)
        .concat(discloseToValidations(discloseToSection))
        .concat(repInfoValidations(formType))
        .concat(authorizationToReleaseValidations(authorizationToReleaseSection))
        .concat(discloseSensitiveInfoValidations(disclosureOfSensitiveInformation))
        .concat(informationToReleaseValidations(informationToReleaseSection))
        .concat(deliveryMethodValidations(deliveryMethodSection))
        .concat(purposeOfDisclosureValidations(purposeOfDisclosureSection))
        .concat(supportingDocsValidations(supportingDocsSection, formType, dbFormSpec))
        .concat(supportingDocsValidationsProxy(supportingDocsSection, formType, dbFormSpec))
        .concat(additionalInfoValidations(additionalInfoSection));
};
